import Service from '@/service/aqr'
import { openChat } from '@/data/im'
export default {
    data () {
        return {
            aqr: null
        }
    },
    onLoad ({ recommend_aqr_id, entrance }) {
        if (recommend_aqr_id && (!entrance || entrance.indexOf('楼盘详情') === -1)) {
            this.getAqrBuilding(recommend_aqr_id)
        }
    },
    methods: {
        async getAqrBuilding (id) {
            const data = await Service.getRecommendBuilding(id)
            this.aqr = data
            console.error('getRecommendBuilding', data)
        },
        async changeAqrBuilding () {
            const data = await Service.selectQuestion(this.aqr.question.id)
            openChat(data.consultant_id, {
                recommend_aqr_id: data.id,
                is_redirect: true,
                from: '提问咨询'
            })
        },
        hideAqr () {
            this.aqr = null
        }
    }
}